// extracted by mini-css-extract-plugin
export default {"root":"_3s5k7","priority-primary":"_2vye9","priorityPrimary":"_2vye9","priority-secondary":"_1hVXR","prioritySecondary":"_1hVXR"};